import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox} from '../box-utils/ParentBox.react.js';
import BoxDecorator from '../box-utils/BoxDecorator.react';
import {defineMessages, IntlShape} from 'react-intl';
import {viewWithDataGetPrimaryData} from '../box-utils/PrimaryData';
import PanelColumns from './system/PanelColumns.react';
import StatusIcon from './StatusIcon.react';
//import {forEach} from "../../../../_node_modules/brace/index";


const socNetworks = defineMessages({
    facebook: {id: 'socialNetworks.facebook.profile', 'defaultMessage': 'Facebook profile'},
    aboutMe: {id: 'socialNetworks.aboutMe.profile', 'defaultMessage': 'about.me profile'},
    github: {id: 'socialNetworks.github.profile', 'defaultMessage': 'Github profile with {followers} followers'},
    twitter: {id: 'socialNetworks.twitter.profile', 'defaultMessage': 'Twitter profile with {followers} followers'},
    linkedin: {id: 'socialNetworks.linkedin.profile', 'defaultMessage': 'Linkedin profile'},
    googleplus: {id: 'socialNetworks.googleplus.profile', 'defaultMessage': 'Google+ profile'},
    gravatar: {id: 'socialNetworks.gravatar.profile', 'defaultMessage': 'Gravatar profile'},
    crunchbase: {id: 'socialNetworks.crunchbase.profile', 'defaultMessage': 'Crunchbase profile'},
});

const gender = defineMessages({
    male: {id: 'gender.male', 'defaultMessage': 'Man'},
    female: {id: 'gender.female', 'defaultMessage': 'Woman'},
});

const messages = defineMessages({
    googleMap: {id: 'google.map.seeMap', 'defaultMessage': 'See location on Google Maps'},
    indexedAt: {id: 'com.clearbit.messages.indexedAt', 'defaultMessage': 'indexed at " + {indexedAt}'},
    employeesCount: {id: 'com.clearbit.messages.employeesCount', 'defaultMessage': '{employeesCount} empl.'},
    foundedYear: {id: 'com.clearbit.messages.foundedYear', 'defaultMessage': 'Est. {foundedYear}'},
    tagLabelName: {id: 'com.clearbit.messages.tagLabelName', 'defaultMessage': 'Markets: {tagLabelName}'},
    bio: {id: 'com.clearbit.messages.bio', 'defaultMessage': 'Bio: {bio}'},
    timezone: {id: 'com.clearbit.messages.timezone', 'defaultMessage': 'Timezone: {tzIdentifier} UTC {tzUtcOffsetHours} h'},
});

const companyType = defineMessages({
    education: {id: 'company.type.education', 'defaultMessage': 'Education'},
    government: {id: 'company.type.government', 'defaultMessage': 'Government'},
    nonprofit: {id: 'company.type.nonprofit', 'defaultMessage': 'Nonprofit'},
    private: {id: 'company.type.private', 'defaultMessage': 'Private'},
    public: {id: 'company.type.public', 'defaultMessage': 'Public'},
    personal: {id: 'company.type.personal', 'defaultMessage': 'Personal'},
    other: {id: 'company.type.other', 'defaultMessage': 'Other'},

});

export default class ClearbitInfo extends ParentBox {
    static handlerName = "clearbit-info";

    static propTypes = {
        intl: PropTypes.object.isRequired,
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    rules = {
        "com.dativery.model.entities.emailAddress@catchAll": {
            "key": "catchAll",
            "icon": StatusIcon.WARN,
            "showWhenValue": true,
            "uid": "f37335d0-3822-487f-956c-7957affa35e3"
        }
    };

    getIcon() {
        return 'fa-at';
    }

    getServiceName() {
        if (this.props.viewWithData.view.entityViewDef) {
            return this.props.viewWithData.view.entityViewDef.title;
        } else {
            return '';
        }
    }

    makeLink({link, text, title, prefix, surfix, icon}) {
        let iconTag;
        if (icon) {
            iconTag = <i className={"fa " + icon}/>;
        }
        if (link) {
            return (<a href={prefix + link + surfix} key={title} title={title}>{iconTag}{text}</a>);
        }
        return null;
    }

    myJoin(array) {
        return array.length ? array.reduce((prev, curr) => [prev, ', ', curr]) : null;
    }

    getPreviewData() {
        //return [JSON.parse('{"key":"7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0","organisationId":"78d78115-9350-4aef-9d54-21af3662f888","channelId":"35e31fac-8824-45ad-90ed-2ee302be7532","channelDefId":"9bb39a85-da70-496b-b06b-765a267eb8e7","channelEntityDefId":"4d8bc166-dc6f-40e7-a59d-ec5af2a600a7","entityDefId":"40d32510-2925-4c60-9135-cecf86b481ef","not-stored":true,"organisation":"Martin Ptáček","channel":"Clearbit","0af3cdfc-22f1-4a2a-99f5-36e5caada97a":"https://d1ts43dypk8bqh.cloudfront.net/v1/avatars/7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0","com.dativery.model.entities.avatars@avatarContentUrl":"https://d1ts43dypk8bqh.cloudfront.net/v1/avatars/7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0","9c400362-7b4b-4e9c-9121-007d7592d8ae":"petr@ferschmann.cz","com.dativery.model.components.contactable@email":"petr@ferschmann.cz","80d375a5-833b-435f-aa03-cd6b4f8ed96d":false,"com.clearbit.people@emailProvider":false,"020e2d27-173e-4249-9171-1043d8649ddc":"Dativery s.r.o.","com.dativery.model.sharedFields.companyName@companyName":"Dativery s.r.o.","5d946baf-52da-459e-bdca-091958cb7bd4":"ceo","com.clearbit.people@employmentRole":"ceo","a01caeeb-e35a-4cb9-8ed2-09b22abfafd1":"executive","com.clearbit.people@employmentSeniority":"executive","2fd6c6e0-2463-4079-afff-57f5a0ac317b":"CEO","com.clearbit.people@employmentTitle":"CEO","73660ab9-c59e-49f5-9619-aebbb93ed568":"fersman","com.dativery.model.components.socialMediaLinks@facebookId":"fersman","d575118d-5f7c-4624-be12-6a276a328781":false,"com.clearbit.people@fuzzy":false,"43889c71-545d-4255-9e4f-c51c9d26ecfc":"male","com.dativery.model.entities.persons@gender":"male","98e222d4-78a5-4dee-b2d3-d6824d95fe5d":"Pilsen","com.dativery.model.components.seatAddresses@saCity":"Pilsen","8148959f-1a6b-466a-a96e-95b51a80ef98":"Czechia","com.dativery.model.components.seatAddresses@saCountryNameEN":"Czechia","7c2a5697-b62f-4f4c-8d67-8875a292fe66":"CZ","com.dativery.model.components.seatAddresses@saCountryCode":"CZ","daeec8f8-0a6d-42c5-b0ea-267e58ae19cb":49.7384314,"com.dativery.model.entities.locations@latitude":49.7384314,"9b107a6e-8ad8-4f5d-87f8-c0ac96e9efd5":13.3736371,"com.dativery.model.entities.locations@longitude":13.3736371,"f50fe795-9fb3-4bb4-98b5-02d405d8994a":"Plzeň Region","com.dativery.model.components.seatAddresses@saState":"Plzeň Region","b3c02025-70c1-4a7a-a540-f5bafb7dc689":"Plzeň Region","com.dativery.model.components.seatAddresses@saStateCode":"Plzeň Region","d23c3642-2d19-40f5-935e-5bb0de2030db":"https://avatars2.githubusercontent.com/u/7085411?v=4","com.clearbit.people@githubAvatar":"https://avatars2.githubusercontent.com/u/7085411?v=4","044a01d0-329f-460f-a31f-cc9459ea9da7":"http://www.ferschmann.cz/","com.clearbit.people@githubBlog":"http://www.ferschmann.cz/","e3a729fc-fa44-4413-a652-7f343c91d66f":"Dativery s.r.o., fnx.io s.r.o.","com.clearbit.people@githubCompany":"Dativery s.r.o., fnx.io s.r.o.","caba6858-ab44-4d12-b0fd-00ea32671840":3,"com.clearbit.people@githubFollowers":3,"47a1facd-f015-486d-bcae-5004d6cfef2f":2,"com.clearbit.people@githubFollowing":2,"fcb62fd1-5cfc-4523-b116-2c41a17d566a":"fersman","com.dativery.model.components.socialMediaLinks@githubHandle":"fersman","96bc8c89-e834-448f-a6f5-fbc3c83e9a45":"https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4","com.clearbit.people@gravatarAvatar":"https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4","3ac8c077-1f31-412d-b961-6dc8388ff92d":{"url":"https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4","type":"thumbnail"},"com.clearbit.people@gravatarAvatars":{"url":"https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4","type":"thumbnail"},"bb2336ff-278a-4b06-86a4-9c1322757372":"fersman","com.dativery.model.components.socialMediaLinks@gravatarHandle":"fersman","83facd81-e338-4b42-b96d-bdab229b9221":{"value":"http://www.ferschmann.cz","title":"Blog"},"com.clearbit.people@gravatarUrls":{"value":"http://www.ferschmann.cz","title":"Blog"},"491c22f6-4490-4378-b255-771af400220d":"7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0","com.clearbit.people@personId":"7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0","e51cc1ac-b7f7-4328-9a93-96c147c5d817":"2018-03-09T07:06:22+00:00","com.clearbit.people@indexedAt":"2018-03-09T07:06:22+00:00","93f33ccf-ffb6-4d59-b16f-014a7ada05d8":"in/fersman","com.clearbit.people@linkedInHandle":"in/fersman","ebec8f53-9330-4c5f-bf49-a4dbc88bda8f":"Pilsen, Plzeň Region, CZ","com.dativery.model.entities.locations@locationName":"Pilsen, Plzeň Region, CZ","0273c7f2-9700-45b8-a062-b99b6b8e8603":"Ferschmann","com.dativery.model.entities.persons@lastName":"Ferschmann","e521cb7f-2006-46a7-b275-f58c7bf04661":"Petr Ferschmann","com.dativery.model.entities.persons@fullName":"Petr Ferschmann","d94f0a8e-972a-40b3-9031-7c526cd6880c":"Petr","com.dativery.model.entities.persons@firstName":"Petr","0ee68e53-d556-43d4-9545-8198c7f86d60":"http://www.ferschmann.cz/","com.dativery.model.components.contactable@www":"http://www.ferschmann.cz/","f1ab9752-7f18-46a5-b9de-92a33f00bd61":"Europe/Prague","com.dativery.model.entities.timeZones@tzIdentifier":"Europe/Prague","a1c7bbad-1ff6-46bd-873f-27f3e2fc38ed":1,"com.dativery.model.entities.timeZones@tzUtcOffsetHours":1}')]
        return [
            {
                "key": "7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0",
                "organisationId": "78d78115-9350-4aef-9d54-21af3662f888",
                "channelId": "35e31fac-8824-45ad-90ed-2ee302be7532",
                "channelDefId": "9bb39a85-da70-496b-b06b-765a267eb8e7",
                "channelEntityDefId": "4d8bc166-dc6f-40e7-a59d-ec5af2a600a7",
                "entityDefId": "40d32510-2925-4c60-9135-cecf86b481ef",
                "not-stored": true,
                "organisation": "Martin Ptáček",
                "channel": "Clearbit",
                "0af3cdfc-22f1-4a2a-99f5-36e5caada97a": "https://d1ts43dypk8bqh.cloudfront.net/v1/avatars/7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0",
                "com.dativery.model.entities.avatars@avatarContentUrl": "https://d1ts43dypk8bqh.cloudfront.net/v1/avatars/7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0",
                "9c400362-7b4b-4e9c-9121-007d7592d8ae": "petr@ferschmann.cz",
                "com.dativery.model.components.contactable@email": "petr@ferschmann.cz",
                "80d375a5-833b-435f-aa03-cd6b4f8ed96d": false,
                "com.clearbit.people@emailProvider": false,
                "020e2d27-173e-4249-9171-1043d8649ddc": "Dativery s.r.o.",
                "com.dativery.model.sharedFields.companyName@companyName": "Dativery s.r.o.",
                "5d946baf-52da-459e-bdca-091958cb7bd4": "ceo",
                "com.clearbit.people@employmentRole": "ceo",
                "a01caeeb-e35a-4cb9-8ed2-09b22abfafd1": "executive",
                "com.clearbit.people@employmentSeniority": "executive",
                "2fd6c6e0-2463-4079-afff-57f5a0ac317b": "CEO",
                "com.clearbit.people@employmentTitle": "CEO",
                "73660ab9-c59e-49f5-9619-aebbb93ed568": "fersman",
                "com.dativery.model.components.socialMediaLinks@facebookId": "fersman",
                "d575118d-5f7c-4624-be12-6a276a328781": false,
                "com.clearbit.people@fuzzy": false,
                "43889c71-545d-4255-9e4f-c51c9d26ecfc": "male",
                "com.dativery.model.entities.persons@gender": "male",
                "98e222d4-78a5-4dee-b2d3-d6824d95fe5d": "Pilsen",
                "com.dativery.model.components.seatAddresses@saCity": "Pilsen",
                "8148959f-1a6b-466a-a96e-95b51a80ef98": "Czechia",
                "com.dativery.model.components.seatAddresses@saCountryNameEN": "Czechia",
                "7c2a5697-b62f-4f4c-8d67-8875a292fe66": "CZ",
                "com.dativery.model.components.seatAddresses@saCountryCode": "CZ",
                "daeec8f8-0a6d-42c5-b0ea-267e58ae19cb": 49.7384314,
                "com.dativery.model.entities.locations@latitude": 49.7384314,
                "9b107a6e-8ad8-4f5d-87f8-c0ac96e9efd5": 13.3736371,
                "com.dativery.model.entities.locations@longitude": 13.3736371,
                "f50fe795-9fb3-4bb4-98b5-02d405d8994a": "Plzeň Region",
                "com.dativery.model.components.seatAddresses@saState": "Plzeň Region",
                "b3c02025-70c1-4a7a-a540-f5bafb7dc689": "Plzeň Region",
                "com.dativery.model.components.seatAddresses@saStateCode": "Plzeň Region",
                "d23c3642-2d19-40f5-935e-5bb0de2030db": "https://avatars2.githubusercontent.com/u/7085411?v=4",
                "com.clearbit.people@githubAvatar": "https://avatars2.githubusercontent.com/u/7085411?v=4",
                "044a01d0-329f-460f-a31f-cc9459ea9da7": "http://www.ferschmann.cz/",
                "com.clearbit.people@githubBlog": "http://www.ferschmann.cz/",
                "e3a729fc-fa44-4413-a652-7f343c91d66f": "Dativery s.r.o., fnx.io s.r.o.",
                "com.clearbit.people@githubCompany": "Dativery s.r.o., fnx.io s.r.o.",
                "caba6858-ab44-4d12-b0fd-00ea32671840": 3,
                "com.clearbit.people@githubFollowers": 3,
                "47a1facd-f015-486d-bcae-5004d6cfef2f": 2,
                "com.clearbit.people@githubFollowing": 2,
                "fcb62fd1-5cfc-4523-b116-2c41a17d566a": "fersman",
                "com.dativery.model.components.socialMediaLinks@githubHandle": "fersman",
                "96bc8c89-e834-448f-a6f5-fbc3c83e9a45": "https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4",
                "com.clearbit.people@gravatarAvatar": "https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4",
                "3ac8c077-1f31-412d-b961-6dc8388ff92d": {
                    "url": "https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4",
                    "type": "thumbnail"
                },
                "com.clearbit.people@gravatarAvatars": {
                    "url": "https://secure.gravatar.com/avatar/71f8dfbfa4d0323bec731f214e7372b4",
                    "type": "thumbnail"
                },
                "bb2336ff-278a-4b06-86a4-9c1322757372": "fersman",
                "com.dativery.model.components.socialMediaLinks@gravatarHandle": "fersman",
                "83facd81-e338-4b42-b96d-bdab229b9221": {
                    "value": "http://www.ferschmann.cz",
                    "title": "Blog"
                },
                "com.clearbit.people@gravatarUrls": {
                    "value": "http://www.ferschmann.cz",
                    "title": "Blog"
                },
                "491c22f6-4490-4378-b255-771af400220d": "7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0",
                "com.clearbit.people@personId": "7b03b7f3-ee79-4ee4-bd72-bff4094f2ba0",
                "e51cc1ac-b7f7-4328-9a93-96c147c5d817": "2018-03-09T07:06:22+00:00",
                "com.clearbit.people@indexedAt": "2018-03-09T07:06:22+00:00",
                "93f33ccf-ffb6-4d59-b16f-014a7ada05d8": "in/fersman",
                "com.clearbit.people@linkedInHandle": "in/fersman",
                "ebec8f53-9330-4c5f-bf49-a4dbc88bda8f": "Pilsen, Plzeň Region, CZ",
                "com.dativery.model.entities.locations@locationName": "Pilsen, Plzeň Region, CZ",
                "0273c7f2-9700-45b8-a062-b99b6b8e8603": "Ferschmann",
                "com.dativery.model.entities.persons@lastName": "Ferschmann",
                "e521cb7f-2006-46a7-b275-f58c7bf04661": "Petr Ferschmann",
                "com.dativery.model.entities.persons@fullName": "Petr Ferschmann",
                "d94f0a8e-972a-40b3-9031-7c526cd6880c": "Petr",
                "com.dativery.model.entities.persons@firstName": "Petr",
                "0ee68e53-d556-43d4-9545-8198c7f86d60": "http://www.ferschmann.cz/",
                "com.dativery.model.components.contactable@www": "http://www.ferschmann.cz/",
                "f1ab9752-7f18-46a5-b9de-92a33f00bd61": "Europe/Prague",
                "com.dativery.model.entities.timeZones@tzIdentifier": "Europe/Prague",
                "a1c7bbad-1ff6-46bd-873f-27f3e2fc38ed": 1,
                "com.dativery.model.entities.timeZones@tzUtcOffsetHours": 1
            },
            // {
            //     "com.dativery.model.entities.emailAddress@domainPart": "example.com",
            //     "com.dativery.model.entities.emailAddress@emailAddress": "suppresed@example.com",
            //     "com.mailboxvalidator.emailAddresses@suppressed": true,
            // },
        ];
    }


        getAvatar(values) {//todo
            let key = "com.dativery.model.entities.avatars@avatarContentUrl";
            if (values[key]) {
                return (<div className="dativeryValue" style={{backgroundImage: 'url(' + values[key] + ')'}}></div>);//dont work
            }
            return (<span className="fa fa-user" style={{color: 'grey', fontSize: '22px'}}></span>);
        }

        getName(values)
        {
            let fullName = values["com.dativery.model.entities.persons@fullName"];
            if (fullName) {
                return fullName;
            }
            return values["com.dativery.model.entities.persons@firstName"] + " " + values["com.dativery.model.entities.persons@lastName"];
        }

    getGenderIcon(values)
    {
        let g = values["com.dativery.model.entities.persons@gender"];
        if (g === "male") {
            return (<i className="fa fa-male" title={this.props.intl.formatMessage(gender[g])}/>);
        } else if (g === "female") {
            return (<i className="fa fa-female" title={this.props.intl.formatMessage(gender[g])}/>);
        }
        return null;
    }

    getIntContacts(values) {
        let response = [];

        let email = values["com.dativery.model.components.contactable@email"];
        this.makeLinkPush(response, {
            "link": "mailto:" + email,
            "title": email,
            "icon":"fa-at"});

        let www = values["com.dativery.model.components.contactable@www"];
        this.makeLinkPush(response, {
            "link": www,
            "title": www,
            "icon":"fa-globe"});

        return this.myJoin(response);
    }

    makeLinkPush(response, args) {
        let res = this.makeLink(args);
        if (res) {
            response.push(res);
        }
    }

    getSocialNetworks(values) {
        let response = [];

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@facebookId"],
            "title": this.props.intl.formatMessage(socNetworks["facebook"]),
            "prefix":"https://www.facebook.com/",
            "icon":"fa-facebook-f"});

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@aboutmeHandle"],
            "title": this.props.intl.formatMessage(socNetworks["aboutMe"]),
            "prefix":"https://about.me/",
            "icon":"fa-user"});//todo

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@githubHandle"],
            "title": this.props.intl.formatMessage(socNetworks["twitter"], {followers: values["com.clearbit.people@githubFollowers"]}),
            "prefix":"https://github.com/",
            "icon":"fa-github"});

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@twitterHandle"],
            "title": this.props.intl.formatMessage(socNetworks["twitter"], {followers: values["com.clearbit.people@twitterFollowers"]}),
            "prefix":"https://twitter.com/",
            "icon":"fa-twitter"});

        this.makeLinkPush(response, {
            "link": values["com.clearbit.people@linkedInHandle"],
            "title": this.props.intl.formatMessage(socNetworks["linkedin"]),
            "prefix":"https://www.linkedin.com/",
            "icon":"fa-linkedin"});

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@googlePlusHandle"],
            "title": this.props.intl.formatMessage(socNetworks["googleplus"]),
            "prefix":"https://plus.google.com/",
            "icon":"fa-google-plus"});

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@gravatarHandle"],
            "title": this.props.intl.formatMessage(socNetworks["gravatar"]),
            "prefix":"https://gravatar.com/",
            "icon":"fa-user"});//todo

        return this.myJoin(response);
    }

    getBio(values)
    {
        let bio = values["com.clearbit.people@bio"];
        if (bio) {
            return (<div key="bio">{this.props.intl.formatMessage(messages["bio"], {bio: bio})}</div>);
        }
        return null;
    }

    getLocation(values) {
        let response = [];

        let saCountryNameEN = values["com.dativery.model.components.seatAddresses@saCountryNameEN"];
        let locationName = values["com.dativery.model.entities.locations@locationName"];

        if (saCountryNameEN) {
            let address = [];

            let city = values["com.dativery.model.components.seatAddresses@city"];
            city ? address.push(city) : null;
            let saState = values["com.dativery.model.components.seatAddresses@saState"];
            saState ? address.push(saState) : null;
            address.push(saCountryNameEN);

            response.push(this.myJoin(address));
        } else if (locationName) {

            response.push(locationName);
        }

        let latitude = values["com.dativery.model.entities.locations@latitude"];
        let longitude = values["com.dativery.model.entities.locations@longitude"];
        if (latitude && longitude) {
            this.makeLinkPush(response, {
                "link": latitude + "," + longitude + ",13z",
                "title": this.props.intl.formatMessage(messages["googleMap"]),
                "prefix": "https://www.google.cz/maps/@",
                "icon": "fa-map"
            });
        }

        let tzUtcOffsetHours = values["com.dativery.model.entities.timeZones@tzUtcOffsetHours"];
        let tzIdentifier = values["com.dativery.model.entities.timeZones@tzIdentifier"];
        if (tzUtcOffsetHours && tzIdentifier) {
            response.push(this.props.intl.formatMessage(messages["timezone"], {tzIdentifier: tzIdentifier, tzUtcOffsetHours: tzUtcOffsetHours}));//todo localtime
        }

        return (<div key="location">{this.myJoin(response)}</div>);
    }

    getEmployment(values) {
        let response = [];

        let companyName = values["com.dativery.model.sharedFields.companyName@companyName"];
        if (companyName) {
            response.push(companyName);
        }

        let employmentDomain = values["com.clearbit.people@employmentDomain"];
        if (employmentDomain) {
            response.push(employmentDomain);
        }

        let employmentTitle = values["com.clearbit.people@employmentTitle"];
        if (employmentTitle) {
            response.push(employmentTitle);
        }

        let employmentRole = values["com.clearbit.people@employmentRole"];
        if (employmentRole) {
            response.push(employmentRole);
        }
        return (<div key="employment">{this.myJoin(response)}</div>);
    }

    getIndexed(values) {// todo
        let indexedAt = values["com.clearbit.people@indexedAt"];
        if (indexedAt) {
            return (<div key="indexed"><i>{this.props.intl.formatMessage(messages["indexedAt"], {indexedAt: indexedAt})}</i></div>);
        }
        return null;
    }

    getPerson(values) {
        let name = this.getName(values);
        if (name) {
            return (
                <div key="person">
                    <div key="personHead"><strong>Person</strong></div>
                    <div key="name">{this.getAvatar(values)} <strong>{name}</strong> {this.getGenderIcon(values)} {this.getIntContacts(values)} {this.getSocialNetworks(values)}</div>
                    {this.getBio(values)}
                    {this.getLocation(values)}
                    {this.getEmployment(values)}
                    {this.getIndexed(values)}
                </div>
            );
        }
        return null;
    }

    getCompanyLogo(values) {//todo
        let type = values["com.dativery.model.entities.files@fileContentUrl"];
        return type ? this.props.intl.formatMessage(companyType[type]) : null;
    }

    getCompanyName(values) {
        let nameForDisplay = values["com.dativery.model.entities.companies@nameForDisplay"];
        return nameForDisplay ? nameForDisplay : values["com.dativery.model.entities.companies@name"];
    }

    getCompanyType(values) {
        let type = values["com.clearbit.companies@type"];
        return type ? this.props.intl.formatMessage(companyType[type]) : null;
    }



    getCompanySocialNetworks(values) {
        let response = [];

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@facebookId"],
            "title": this.props.intl.formatMessage(socNetworks["facebook"]),
            "prefix":"https://www.facebook.com/",
            "icon":"fa-facebook-f"});

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@twitterHandle"],
            "title": this.props.intl.formatMessage(socNetworks["twitter"], {followers: values["com.clearbit.companies@twitterFollowers"]}),
            "prefix":"https://twitter.com/",
            "icon":"fa-twitter"});

        this.makeLinkPush(response, {
            "link": values["com.clearbit.people@linkedInHandle"],
            "title": this.props.intl.formatMessage(socNetworks["linkedin"]),
            "prefix":"https://www.linkedin.com/",
            "icon":"fa-linkedin"});

        this.makeLinkPush(response, {
            "link": values["com.dativery.model.components.socialMediaLinks@crunchbaseHandle"],
            "title": this.props.intl.formatMessage(socNetworks["crunchbase"]),
            "prefix":"https://www.crunchbase.com/",
            "icon":"fa-user"});//todo

        return this.myJoin(response);
    }

    getCompanyDescription(values) {
        let description = values["com.dativery.model.sharedFields.description@description"];

		let truncate = function(text, limit) {
			if (text.trim().length < limit) {
				return text.trim();
			}

			let letterLimited = text.trim().split('').slice(0, limit).trim();

			if (letterLimited.length < limit) {
				return letterLimited + '…';
			}

			let words = letterLimited.split(' ');

			let wordLimited = words.slice(0, words.length - 1).join(' ');
			return wordLimited + '…';
		};

        return description ? (<i title={description}>{truncate(description, 100)}</i>) : null;//todo style to show max text on one row
    }
    getCompanyIndustry(values) {
        let response = [];
        let categorySector = values["com.clearbit.companies@categorySector"];
        let categorySubindustry = values["com.clearbit.companies@categorySubindustry"];
        if (categorySector) {
            response.push(categorySector);
        }

        if (categorySubindustry) {
            response.push(categorySubindustry);
        }

        return this.myJoin(response);
    }

    getCompanyMarkets(values) {
        let tagLabelName = values["com.dativery.model.entities.tagsLabels@tagLabelName"];
        if (tagLabelName) {
            return this.props.intl.formatMessage(messages["tagLabelName"], {tagLabelName: tagLabelName});
        }
        return null;
    }

    getCompanyMetrics(values) {
        let response = [];

        let foundedYear = values["com.dativery.model.entities.companies@foundedYear"];
        if (foundedYear) {
            response.push(this.props.intl.formatMessage(messages["foundedYear"], {foundedYear: foundedYear}));
        }

        let numberOfEmployees = values["com.dativery.model.entities.companies@numberOfEmployees"];
        let employeesCountRange = values["com.dativery.model.entities.companyMagnitudesEmployees@employeesCountRange"];
        if (numberOfEmployees) {
            response.push(this.props.intl.formatMessage(messages["employeesCount"], {employeesCount: numberOfEmployees}));
        } else if (employeesCountRange) {
            response.push(this.props.intl.formatMessage(messages["employeesCount"], {employeesCount: employeesCountRange}));
        }

        return this.myJoin(response);
    }

    getCompanyContacts(values) {
        let response = [];

        let email = values["com.dativery.model.components.contactable@email"];
        this.makeLinkPush(response, {
            "link": "mailto:" + email,
            "title": email,
            "icon":"fa-at"});

        let phone = values["com.dativery.model.components.contactable@phonePrimary"];
        this.makeLinkPush(response, {
            "link": "tel:" + phone,
            "title": phone,
            "icon":"fa-phone"});

        return this.myJoin(response);
    }

    getCompanyLocation(values) {
        let response = [];

        let saCountryNameEN = values["com.dativery.model.components.seatAddresses@saCountryNameEN"];
        let locationName = values["com.dativery.model.entities.locations@locationName"];

        if (saCountryNameEN) {
            let address = [];
            let value;

            value = values["com.dativery.model.components.seatAddresses@saStreetName"];
            value ? address.push(value) : null;
            value = values["com.dativery.model.components.seatAddresses@saStreetNo"];
            value ? address.push(value) : null;
            value = values["com.dativery.model.components.seatAddresses@city"];
            value ? address.push(value) : null;
            value = values["com.dativery.model.components.seatAddresses@saState"];
            value ? address.push(value) : null;
            address.push(saCountryNameEN);

            response.push(this.myJoin(address));
        } else if (locationName) {

            response.push(locationName);
        }

        let latitude = values["com.dativery.model.entities.locations@latitude"];
        let longitude = values["com.dativery.model.entities.locations@longitude"];
        if (latitude && longitude) {
            this.makeLinkPush(response, {
                "link": latitude + "," + longitude + ",13z",
                "title": this.props.intl.formatMessage(messages["googleMap"]),
                "prefix": "https://www.google.cz/maps/@",
                "icon": "fa-map"
            });
        }

        let tzUtcOffsetHours = values["com.dativery.model.entities.timeZones@tzUtcOffsetHours"];
        let tzIdentifier = values["com.dativery.model.entities.timeZones@tzIdentifier"];
        if (tzUtcOffsetHours && tzIdentifier) {
            response.push(this.props.intl.formatMessage(messages["timezone"], {tzIdentifier: tzIdentifier, tzUtcOffsetHours: tzUtcOffsetHours}));//todo localtime
        }

        return this.myJoin(response);
    }

    getCompanyIndexed(values) {
        let indexedAt = values["com.clearbit.companies@indexedAt"];
        if (indexedAt) {
            return "(" + this.props.intl.formatMessage(messages["indexedAt"], {indexedAt: indexedAt}) + ")";
        }
        return null;
    }

    getCompany(values) {
        let companyName = this.getCompanyName(values);
        if (companyName) {
            return (
                <div>
                    <strong>Company</strong><br />
                    {this.getCompanyLogo(values)} <strong>{companyName}</strong>{this.getCompanyType(values)}{this.getCompanySocialNetworks(values)}<br />
                    {this.getCompanyDescription(values)}<br />
                    {this.getCompanyIndustry(values)}<br />
                    {this.getCompanyMarkets(values)}<br />
                    {this.getCompanyMetrics(values)}<br />
                    {this.getCompanyContacts(values)}<br />
                    {this.getCompanyLocation(values)}<br />
                    {this.getCompanyIndexed(values)}<br />
                    <br />
                </div>
            );
        }
        return null;
    }

        renderInfo(values, idx) {
        // debugger;
            return (
                <div key={idx}>
                    <strong>{values["com.dativery.model.components.contactable@email"]}</strong><br />
                    {this.getPerson(values)}
                    {this.getCompany(values)}
                </div>
            );
        }

        render()
        {
            let data = this.props.isPreview ? this.getPreviewData() : viewWithDataGetPrimaryData(this.props.viewWithData);

            return (
                <BoxDecorator className={this.handlerName} icon={this.getIcon()} isPreview={this.props.isPreview}
                              padding title={this.getServiceName()}>
                    <PanelColumns className="boxOneTimeFontSize">
                        {data.map((values, idx) => {
                            return this.renderInfo(values, idx);
                        })}
                    </PanelColumns>
                </BoxDecorator>
            );
        }
    }
